import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const languages = [
    { code: 'uk', name: 'Укр' },
    { code: 'ru', name: 'Рус' },
    { code: 'cs', name: 'Cze' },
    { code: 'en', name: 'Eng' }
  ];

  const currentLang = languages.find(lang => lang.code === currentLanguage);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsDropdownOpen(false);
  };

  return (
    <div className="language-switcher">
      {/* Desktop version */}
      <div className="desktop-lang-switcher">
        {languages.map((lang) => (
          <button
            key={lang.code}
            className={`lang-btn ${currentLanguage === lang.code ? 'active' : ''}`}
            onClick={() => changeLanguage(lang.code)}
            aria-label={`Switch to ${lang.name}`}
          >
            {lang.name}
          </button>
        ))}
      </div>

      {/* Mobile dropdown version */}
      <div className="mobile-lang-switcher">
        <button 
          className="lang-dropdown-btn"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          aria-label="Language selector"
        >
          {currentLang?.name}
          <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>▼</span>
        </button>
        
        {isDropdownOpen && (
          <div className="lang-dropdown">
            {languages.map((lang) => (
              <button
                key={lang.code}
                className={`lang-dropdown-item ${currentLanguage === lang.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                {lang.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
